import { AxiosError } from "axios";

const somethingWrong = {
  status: 500,
  message: "Something went wrong.",
};

const sessionExpired = {
  status: 401,
  message: "Session expired.",
};

const notFound = {
  status: 404,
  message: "Not found.",
};

const cannotConnect = {
  status: 0,
  message: "Unable to connect to server.",
};

export function handleAxiosError(error: AxiosError) {
  if (error.response) {
    const { status, data } = error.response;
    if (status >= 500) {
      return somethingWrong;
    }
    if (status === 419) {
      return sessionExpired;
    }
    if (status === 401) {
      if(error.config?.url?.includes("login")) {
        return data;
      }
      return sessionExpired;
    }
    if (status === 404) {
      return notFound;
    }
    return data;
  }
  if (error.request) {
    return cannotConnect;
  }
  return somethingWrong;
}
